__turbopack_context__.v({
  "breadcrumbSpacing": "index-module__PW4cIa__breadcrumbSpacing",
  "colSpacing": "index-module__PW4cIa__colSpacing",
  "sectionSpacingResponsive": "index-module__PW4cIa__sectionSpacingResponsive",
});
